export const updateSigningRoomRequest = (signing_room_request) => ({
  type: 'UPDATE_SIGNING_ROOM_REQUEST',
  signing_room_request,
});

export const updateSigner = (signer) => ({
  type: 'UPDATE_SIGNER',
  signer,
});